import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOMenuExternalLink } from "src/app/shared/models/oo-menu";

@Component({
	selector: "app-oo-menu-external-link",
	templateUrl: "./oo-menu-external-link.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class OoMenuExternalLinkComponent implements OnInit {
	@Input() externalLinks: OOMenuExternalLink[];
	@Output() externalLinksChange = new EventEmitter<OOMenuExternalLink[]>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	constructor(public app: AppService) {}

	ngOnInit(): void {}

	addExternalLink() {
		this.externalLinks.push(new OOMenuExternalLink());
	}
}
